var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRwcLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 105.94,
    cy: 111.837,
    r: 30.027,
    gradientTransform: "matrix(.94088 .33874 -.6845 1.90126 82.815 -136.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#ebecff",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d8dbff",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c8ccff",
    stopOpacity: 0.658
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#bbc0ff",
    stopOpacity: 0.806
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#b2b8ff",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#adb3ff",
    stopOpacity: 0.977
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abb1ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 109.844,
    cy: 115.664,
    r: 35.09,
    gradientTransform: "rotate(15.1 755.035 201.178) scale(1 2.47865)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#ebecff",
    stopOpacity: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#d8dbff",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c8ccff",
    stopOpacity: 0.658
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#bbc0ff",
    stopOpacity: 0.806
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#b2b8ff",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#adb3ff",
    stopOpacity: 0.977
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abb1ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 120.357,
    cy: 102.736,
    r: 32.791,
    gradientTransform: "matrix(.98229 .18738 -.48545 2.54481 52.005 -181.261)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#abb1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#acb2ff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#afb4ff",
    stopOpacity: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b3b9ff",
    stopOpacity: 0.901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#babfff",
    stopOpacity: 0.821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#c3c7ff",
    stopOpacity: 0.718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cdd1ff",
    stopOpacity: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#daddff",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#e9eaff",
    stopOpacity: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f9f9ff",
    stopOpacity: 0.072
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 61.23,
    cy: 113.931,
    r: 20.522,
    gradientTransform: "rotate(-14.55 -733.532 215.388) scale(1 2.78102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#abb1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#acb2ff",
    stopOpacity: 0.987
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#afb5ff",
    stopOpacity: 0.948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#b5baff",
    stopOpacity: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#bdc2ff",
    stopOpacity: 0.788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#c7cbff",
    stopOpacity: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#d3d7ff",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#e2e4ff",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#f3f4ff",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 102.37,
    cy: 86.747,
    r: 33.156,
    gradientTransform: "rotate(14.359 301.807 111.868) scale(1 1.57919)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#abb1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#acb2ff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#afb4ff",
    stopOpacity: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#b3b9ff",
    stopOpacity: 0.901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#babfff",
    stopOpacity: 0.821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#c3c7ff",
    stopOpacity: 0.718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#cdd1ff",
    stopOpacity: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#daddff",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#e9eaff",
    stopOpacity: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#f9f9ff",
    stopOpacity: 0.072
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 101.287,
    cy: 35.077,
    r: 17.038,
    gradientTransform: "rotate(-43.7 123.332 26.238) scale(1 .496)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 46.706,
    cy: 67.017,
    r: 14.688,
    gradientTransform: "rotate(115.7 37.25 51.971) scale(1 .551)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 83.175,
    y1: 17.714,
    x2: 123.638,
    y2: 167.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616dff",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 112.615,
    y1: 167.022,
    x2: 112.615,
    y2: 32.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00d2"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARTWORK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork-2",
    "data-name": "Artwork"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.387 195.827v-9.184h3.62v9.096c0 2.532 1.267 4.041 3.356 4.041s3.355-1.463 3.355-3.93v-9.207h3.62v9.073c0 4.71-2.842 7.022-7.02 7.022s-6.93-2.332-6.93-6.91zm95.074 26.658c0 3.43-1.761 5.466-4.666 5.466s-4.666-2.098-4.666-5.62v-12.648h-5.035v12.77c0 6.367 3.83 9.612 9.64 9.612s9.76-3.215 9.76-9.767v-12.615h-5.033zm-130.388 6.77a11.826 11.826 0 010-17.04 12.84 12.84 0 019.068-3.16 12.82 12.82 0 019.058 3.16 11.821 11.821 0 010 17.04 12.907 12.907 0 01-9.058 3.132 12.925 12.925 0 01-9.068-3.132zm2.111-8.504a8.374 8.374 0 001.78 5.536 6.265 6.265 0 005.177 2.342 6.363 6.363 0 005.204-2.342 9.648 9.648 0 000-11.07 6.37 6.37 0 00-5.204-2.34 6.354 6.354 0 00-5.178 2.373 8.48 8.48 0 00-1.779 5.5zm44.42-11.068v22.076h13.397l1.582-3.923a30.492 30.492 0 01-7.338.663 23.802 23.802 0 01-2.568-.102v-18.714zm-58.24 22.934l7.745-22.934h-4.834l-4.702 15.155-5.294-15.155h-3.595l-4.964 15.11-5.26-15.11H0l6.459 18.091a10.173 10.173 0 00.919 2.184 5.266 5.266 0 002.236 1.73c.388.175 1.29.481 2.69.923l4.846-14.524L20.512 228a8.826 8.826 0 001.085 2.274 5.59 5.59 0 002.07 1.418c1.184.419 2.085.727 2.698.924zm166.88-15.784a6.03 6.03 0 01-2.102 4.81 7.364 7.364 0 01-5.014 1.712 6.857 6.857 0 01-3.628-.92v9.33h-5.077v-22.122a56.929 56.929 0 015.938-.26q6.686 0 8.99 4.018a6.894 6.894 0 01.893 3.432zm-5.17-.161a3.515 3.515 0 00-1.29-2.916 4.763 4.763 0 00-3.056-.92c-.423 0-.833.028-1.228.032v8.057a5.186 5.186 0 00.825.06c3.179 0 4.748-1.439 4.748-4.313zm-89.588-13.934a8.618 8.618 0 005.904-2.18v-6.076h-3.402v5.032a5.788 5.788 0 01-2.317.487 5.29 5.29 0 01-3.959-1.563 5.94 5.94 0 01.012-8.067 5.326 5.326 0 014.016-1.599 8.12 8.12 0 014.328 1.135v-2.777a11.225 11.225 0 00-4.86-.904 8.722 8.722 0 00-6.274 2.223 7.897 7.897 0 00-2.38 5.835 7.5 7.5 0 002.314 5.944 9.803 9.803 0 006.618 2.51zm36.446 26.516a13.05 13.05 0 008.926 3.01 16.26 16.26 0 005.841-.958l2.013-4.85a12.233 12.233 0 01-7.025 2.074 7.363 7.363 0 01-5.624-2.128 7.917 7.917 0 01-2.056-5.759 7.693 7.693 0 012.078-5.506 7.078 7.078 0 015.376-2.194 9.88 9.88 0 015.704 1.456v-4.259a16.3 16.3 0 00-6.036-1.085 13.177 13.177 0 00-8.963 3.103 10.683 10.683 0 00-3.83 8.535 10.818 10.818 0 003.596 8.56zM111.055 202.4a33.049 33.049 0 01-3.982-.186V186.5c1.592-.142 2.926-.104 4.005-.104a11.18 11.18 0 015.249 1.024 3.292 3.292 0 011.506 2.992 3.35 3.35 0 01-1.647 2.61 8.62 8.62 0 01-.286.167 2.219 2.219 0 01-.283.112 5.5 5.5 0 011.731.697q.13.082.251.166a3.854 3.854 0 011.514 2.72c.006.118.01.241.01.37a4.27 4.27 0 01-2.834 4.236 12.08 12.08 0 01-5.234.912zm-.585-9.898h1.105c1.804.015 2.988-.631 2.988-1.942 0-1.467-1.354-1.943-3.158-1.943h-.935zm0 7.605c.276.015 1.144.024 1.593.024 2.605 0 3.679-1.015 3.679-2.69 0-1.78-1.537-2.669-3.805-2.669-.448 0-1.19.01-1.467.024zm17.764-4.102l6.012-9.363h-3.956l-3.8 6.1-3.8-6.1h-3.955l6.011 9.363v6.149h3.488zm-9.766 33.083q-3.73 2.937-10.384 2.933a38.028 38.028 0 01-6.033-.393v-21.852a39.91 39.91 0 016.033-.393q6.656 0 10.384 2.93a10.154 10.154 0 013.984 8.406 10.049 10.049 0 01-3.984 8.37zm-1.586-8.355a7.61 7.61 0 00-2.207-5.91 8.672 8.672 0 00-6.028-1.912c-.464 0-.968.02-1.517.063v15.457c.55.044 1.053.067 1.517.067q8.235 0 8.235-7.765zm-48.69-18.58l-5.63-7.082v7.083h-3.564v-15.513a29.853 29.853 0 013.94-.206 10.288 10.288 0 015.103.993 4.066 4.066 0 01-1.232 7.733l5.76 6.993zm-1.33-11.001c0-1.703-1.431-2.287-3.436-2.287a6.997 6.997 0 00-.863.051v4.66a5.666 5.666 0 00.863.058c2.005 0 3.437-.868 3.437-2.482zm1.166 40.606h-5.079v-22.076a39.145 39.145 0 015.444-.3q4.816 0 7.15 1.412a6.22 6.22 0 011.91 9.1 5.431 5.431 0 01-3.46 1.927l7.808 9.937h-6.226l-7.547-10.082zm0-12.158c.33.019.679.03 1.056.03q4.281 0 4.286-3.406 0-3.384-4.286-3.385c-.377 0-.725.011-1.056.037zm16.542 27.36a5.098 5.098 0 015.197-5.381 6.7 6.7 0 013.978 1.012v-2.967a10.583 10.583 0 00-4.208-.758c-4.806 0-8.923 3.036-8.923 8.117 0 5.174 3.795 8.072 8.739 8.072a11.643 11.643 0 004.07-.667l1.403-3.38a8.07 8.07 0 01-4.898 1.448c-3.38 0-5.358-2.162-5.358-5.496zm15.833 5.381v-4.714h4.806v-2.3h-4.806v-3.748c.53-.023 1.08-.023 1.633-.023a16.265 16.265 0 013.817.299v-2.576h-8.991v15.408h9.52l1.173-2.875a21.025 21.025 0 01-5.22.598q-.966 0-1.932-.069zM75.1 248.638l-7.773-9.36h-3.288v15.408h3.104v-10.141l6.899 8.301a6.393 6.393 0 004.162 2.346v-15.914H75.1zm44.45 3.68c1.908-2.208 5.587-6.302 5.587-9.314 0-2.967-2.644-4.185-5.242-4.185a9.98 9.98 0 00-4.324.966l-.551 3.012a7.345 7.345 0 014.115-1.31c1.219 0 2.438.528 2.438 1.93a3.764 3.764 0 01-.506 1.726 22.134 22.134 0 01-2.138 3.127 65.936 65.936 0 01-5.45 6.416h11.98l.966-2.668a20.326 20.326 0 01-4.254.391c-.874 0-1.748-.046-2.621-.092zm47.504-6.393a3.129 3.129 0 002.14-3.128c0-2.898-2.853-3.955-5.313-3.955a10.604 10.604 0 00-3.587.62l-.46 2.829a7.96 7.96 0 013.426-.782c1.127 0 2.438.322 2.438 1.702 0 1.793-2.139 1.793-3.427 1.793-.322 0-.644 0-.966-.022v2.69a13.964 13.964 0 011.955-.115c1.472 0 3.38.414 3.38 2.254 0 2.139-2.161 2.667-3.886 2.667a15.593 15.593 0 01-4.254-.598l1.288 2.944a13.464 13.464 0 002.897.298c3.335 0 7.635-1.31 7.635-5.357 0-2.185-1.219-3.334-3.266-3.84zm-111.18-6.67l6.439 15.43H58.38l-1.701-4.345h-5.473l-1.679 4.346h-7.109l-5.266-7.037v7.037h-3.54v-15.43a26.217 26.217 0 013.793-.207 10.022 10.022 0 014.99.989 4.363 4.363 0 012.185 3.68 3.791 3.791 0 01-3.265 4.023l5 6.371 6.133-14.856zm-14.996 4.576c0-1.747-1.45-2.368-2.99-2.368-.253 0-.483 0-.736.023v4.715c.253 0 .483.023.736.023 1.54 0 2.99-.621 2.99-2.393zm14.812 4.025l-1.794-4.53-1.748 4.53zm-32.981 6.83h3.564v-7.06h4.392v-2.3h-4.392v-3.748c.437-.023.897-.023 1.334-.023a19.154 19.154 0 013.817.299v-2.576h-8.715zm127.167-2.369c1.908-2.207 5.588-6.3 5.588-9.313 0-2.967-2.645-4.185-5.243-4.185a9.982 9.982 0 00-4.324.966l-.552 3.012a7.348 7.348 0 014.117-1.31c1.218 0 2.437.528 2.437 1.93a3.764 3.764 0 01-.505 1.726 22.135 22.135 0 01-2.14 3.127 65.9 65.9 0 01-5.45 6.416h11.982l.966-2.668a20.323 20.323 0 01-4.255.391c-.873 0-1.747-.046-2.621-.092zm-6.49-5.358c0 4.6-3.151 8.163-7.842 8.163-4.715 0-7.865-3.564-7.865-8.163 0-4.6 3.15-8.163 7.865-8.163 4.69 0 7.841 3.564 7.841 8.163zm-3.98 0c0-2.414-.965-5.45-3.862-5.45-2.875 0-3.887 3.059-3.887 5.45 0 2.415.966 5.427 3.887 5.427 2.897 0 3.863-3.012 3.863-5.427zm-55.872-137.38c-1.394 11.548-1.204 22.434.628 31.614 2.202 11.033 6.677 18.354 11.972 19.584 4.699 1.09 10.667-2.236 16.624-8.986 3.198-11.198 5.54-25.413 6.987-42.212z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.326 114.123c1.236-12.521 1.95-26.576 2.105-42.03.198-11.24-.021-22.715-.522-33.337-11.39 2.08-27.349 23.98-34.657 55.447a142 142 0 00-3.184 19.92zM73.44 90.237c4.427-18.565 11.875-35.321 21.021-47.27 8.096-10.575 16.98-16.622 25.637-17.614-.447-5.99-.98-11.467-1.565-16.173-28.85 8.69-44.592 19.067-44.592 19.067s-1.098 23.02-.997 36.26c-.01 9.33.168 17.886.496 25.73z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.925 0a81.94 81.94 0 00-17.036 3.974c28.592 119.071-26.539 167.828-26.539 167.828C200.228 131.54 151.925 0 151.925 0M67.753 159.918c-8.128-9.18-15.127-22.403-19.707-37.234-4.58-14.83-6.257-29.697-4.721-41.861 1.164-9.22 4.126-16.382 8.577-21 .305-6.716.802-12.855 1.285-18.13l.148-1.621a177.24 177.24 0 00-22.519 17.237 183.34 183.34 0 00-.814 19.708 139.969 139.969 0 005.646 38.697 96.723 96.723 0 0018.631 34.681c12.321 14.387 25.091 19.633 28.402 20.813-5.005-2-10.067-5.8-14.928-11.29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.534 109.579c-1.394 11.548-1.204 22.434.628 31.614 2.202 11.033 6.677 18.354 11.972 19.584 4.699 1.09 10.667-2.236 16.624-8.986 3.198-11.198 5.54-25.413 6.987-42.212z",
    fill: "url(#radial-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.326 114.123c1.236-12.521 1.95-26.576 2.105-42.03.198-11.24-.021-22.715-.522-33.337-11.39 2.08-27.349 23.98-34.657 55.447a142 142 0 00-3.184 19.92z",
    fill: "url(#radial-gradient-2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.925 0a81.94 81.94 0 00-17.036 3.974c28.592 119.071-26.539 167.828-26.539 167.828C200.228 131.54 151.925 0 151.925 0",
    fill: "url(#radial-gradient-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.753 159.918c-8.128-9.18-15.127-22.403-19.707-37.234-4.58-14.83-6.257-29.697-4.721-41.861 1.164-9.22 4.126-16.382 8.577-21 .305-6.716.802-12.855 1.285-18.13l.148-1.621a177.24 177.24 0 00-22.519 17.237 183.34 183.34 0 00-.814 19.708 139.969 139.969 0 005.646 38.697 96.723 96.723 0 0018.631 34.681c12.321 14.387 25.091 19.633 28.402 20.813-5.005-2-10.067-5.8-14.928-11.29z",
    fill: "url(#radial-gradient-4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.44 90.237c4.427-18.565 11.875-35.321 21.021-47.27 8.096-10.575 16.98-16.622 25.637-17.614-.447-5.99-.98-11.467-1.565-16.173-28.85 8.69-44.592 19.067-44.592 19.067s-1.098 23.02-.997 36.26c-.01 9.33.168 17.886.496 25.73z",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.35 171.802s55.131-48.757 26.54-167.827A81.92 81.92 0 01151.924 0s48.303 131.54-43.575 171.802zm4.408-20.011c5.359-18.765 8.336-45.943 8.673-79.697.198-11.24-.021-22.716-.522-33.338-11.39 2.08-27.349 23.98-34.657 55.447-3.977 17.124-4.72 33.812-2.09 46.99 2.201 11.033 6.677 18.354 11.972 19.584 4.699 1.09 10.667-2.236 16.624-8.986zM73.44 90.237c4.427-18.565 11.875-35.321 21.021-47.27 8.096-10.575 16.98-16.622 25.637-17.614-.447-5.99-.98-11.467-1.565-16.173-28.85 8.69-44.592 19.067-44.592 19.067s-1.098 23.02-.997 36.26c-.01 9.33.168 17.886.496 25.73zm-5.687 69.681c-8.128-9.18-15.127-22.403-19.707-37.234-4.58-14.83-6.257-29.697-4.721-41.861 1.164-9.22 4.126-16.382 8.577-21 .305-6.716.802-12.855 1.285-18.13l.148-1.621a177.262 177.262 0 00-22.519 17.237 183.4 183.4 0 00-.815 19.708 139.973 139.973 0 005.647 38.697 96.725 96.725 0 0018.631 34.682c12.322 14.386 25.091 19.632 28.402 20.812-5.005-2-10.067-5.8-14.928-11.29z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fill: "url(#linear-gradient)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.272 166.877c-16.54-2.036-18.982-19.595-19.874-30.66-1.098-13.624 1.059-34.295 5.598-48.785a127.422 127.422 0 019.259-23.723 114.834 114.834 0 0114.922-23.05c9.114-10.909 21.675-10.296 29.026-2.171q-.24-1.954-.511-3.94a23.52 23.52 0 00-13.201-8.783c-10.874-2.524-22.604 3.584-33.03 17.203-9.3 12.149-16.844 29.269-21.242 48.208-4.398 18.938-5.172 37.631-2.179 52.635 3.356 16.82 11.193 27.473 22.067 29.999a21.426 21.426 0 003.994.528 28.41 28.41 0 0011.252-2.539 59.934 59.934 0 006.67-7.493 21.638 21.638 0 01-12.75 2.57z",
    fill: "url(#radial-gradient-6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.675 59.59c-3.374 2.456-7.196 7.795-8.375 17.128-1.154 9.145-.437 20.034 2.078 31.42a79.996 79.996 0 01-1.51-25.605c1.016-8.04 3.78-13.693 7.215-14.754a4.898 4.898 0 011.45-.207c2.062 0 4.628 1.096 7.433 3.227q-.025-3.085-.022-6.292c-.014-1.783-.006-3.745.019-5.804v.015c-3.134-.927-6.002-.792-8.287.872z",
    fill: "#ff00d2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3 76.718c1.179-9.333 5.001-14.672 8.376-17.128 2.285-1.664 5.153-1.8 8.287-.872.013-1.112.03-2.252.052-3.408a19.86 19.86 0 00-12.96-.575c-9.017 2.785-14.958 12.05-16.73 26.088-1.536 12.164.14 27.03 4.721 41.861 4.58 14.831 11.58 28.054 19.707 37.234 5.013 5.663 10.241 9.527 15.399 11.473.653.259 1.414.479 2.168.736l.022.008c.133.047.272.093.408.14a35.108 35.108 0 0011.303 2.061 21.402 21.402 0 01-3.946-.526c-10.874-2.526-18.71-13.18-22.067-29.999q-.349-1.75-.63-3.566a103.194 103.194 0 01-9.32-21.59 113.416 113.416 0 01-2.712-10.517c-2.515-11.386-3.232-22.275-2.078-31.42z",
    fill: "url(#radial-gradient-7)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.203 38.487c-7.351-8.124-19.912-8.737-29.026 2.173a114.843 114.843 0 00-14.922 23.049c7.946-15.342 17.568-24.727 24.928-25.104a8.198 8.198 0 012.28.193c5.296 1.23 9.771 8.551 11.973 19.584 2.63 13.178 1.887 29.866-2.09 46.99a131.356 131.356 0 01-11.067 30.615v.003a79.354 79.354 0 01-10.521 15.801l-.16.181-.01.01-.145.162-.05.056q-.203.225-.406.445l-.108.116-.09.098-.12.126-.083.09-.19.198-.062.066-.17.175-.032.034q-.221.228-.443.45l-.009.008q-.802.802-1.6 1.516c-4.688 4.204-9.217 6.12-12.946 5.255-5.295-1.23-9.77-8.551-11.972-19.584-2.63-13.178-1.887-29.866 2.09-46.99q.805-3.465 1.744-6.77c-4.539 14.489-6.696 35.16-5.598 48.785.893 11.064 3.334 28.623 19.874 30.658a21.637 21.637 0 0012.75-2.57 105.005 105.005 0 006.753-9.868l.045-.074.169-.279.025-.043c11.945-19.863 26.347-57.138 19.19-115.555z",
    fill: "url(#linear-gradient-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwcLogoWhite);
export default __webpack_public_path__ + "static/media/rwcLogoWhite.6f54e891b0e2dbea252ae689484899b2.svg";
export { ForwardRef as ReactComponent };